var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sound-wrapper"},[_c('div',{staticClass:"togglesound-text"},[_c('a',{attrs:{"type":"button"},on:{"click":_vm.play}},[_vm._v("sound on/off")])]),_c('audio',{ref:"audioElm",attrs:{"src":_vm.track,"loop":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }